"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IClosedDays } from "@/interfaces/closed-days.interface";
import closedDaysService from "@/services/closed-days.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<IClosedDays> | null>;

type GetAllSwrParams = [string, number, number];

const useGetClosedDays = ({ pageNumber, pageSize }: RequestPagination): Return => {
  const fetcher = useSWR<PaginatedResponse<IClosedDays>, Error, GetAllSwrParams>(
    [SWR_KEYS.getClosedDays, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      closedDaysService.getAll({
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetClosedDays;
